export { partySections } from './partyNav'

/** 顶栏主栏目（绿色框） */
export const primaryNavItems = [
  { id: 'home', label: '首页', path: '/' },
  { id: 'intro', label: '学会简介', path: '/intro' },
  { id: 'structure', label: '组织机构', path: '/structure' },
  { id: 'services', label: '学会服务', path: '/services' },
  { id: 'party', label: '党建文化', path: '/party' }
]

/** 首页页脚上方次要入口（红色框）；秘书处「新闻发布」对应站内「通知要闻」 */
export const secondaryNavItems = [
  { id: 'history', label: '学会沿革', path: '/history', moduleCode: 'timeline', icon: 'history' },
  { id: 'gallery', label: '历史相册', path: '/gallery', moduleCode: 'gallery', icon: 'gallery' },
  { id: 'society-announcements', label: '会员公告', path: '/society-announcements', moduleCode: 'announcements', icon: 'announcements' },
  { id: 'news-publish', label: '通知要闻', path: '/news-publish', moduleCode: 'publish', icon: 'news' },
  { id: 'international', label: '国际交流', path: '/international', moduleCode: 'international', icon: 'international' },
  { id: 'regulations', label: '规章条例', path: '/regulations', moduleCode: 'regulations', icon: 'regulations' },
  { id: 'public-downloads', label: '公开文件', path: '/public-downloads', moduleCode: 'public-files', icon: 'files' }
]

export const navItems = [...primaryNavItems, ...secondaryNavItems]

export const branches = [
  '中国古生物学会（总学会）',
  '古无脊椎动物学分会',
  '科普工作委员会',
  '孢粉学分会',
  '微体学分会',
  '化石藻类专业委员会',
  '古植物学分会',
  '地球生物学分会',
  '古生态专业分会',
  '古脊椎动物学分会',
  '生物沉积学分会',
  '新技术新方法专业委员会',
  '教育工作委员会',
  '天体生物学分会'
]

export const notices = [
  {
    type: '通知公告',
    title: '关于开展 2026 年度会员信息确认与会费缴纳工作的通知',
    date: '2026-06-13'
  },
  {
    type: '会议通知',
    title: '第十五届中国古生物学会学术年会第一轮通知',
    date: '2026-06-10'
  },
  {
    type: '党建动态',
    title: '功能性党委组织开展理论学习与学术诚信专题活动',
    date: '2026-06-05'
  }
]

export const paymentStates = [
  { label: '未缴费', tone: 'muted' },
  { label: '入会申请审核中', tone: 'warning' },
  { label: '凭证初审中', tone: 'warning' },
  { label: '待上传发票', tone: 'info' },
  { label: '发票终审中', tone: 'warning' },
  { label: '已确认', tone: 'success' }
]

export const conferences = [
  {
    title: '中国古生物学会 2026 学术年会',
    branch: '中国古生物学会（总学会）',
    time: '2026.09.18 - 09.21',
    city: '南京',
    status: '报名中',
    feeRules: {
      studentMember: 600,
      nonStudentMember: 900,
      studentNonMember: 800,
      nonStudentNonMember: 1200
    },
    materialRules: ['缴费后下载盖章会议通知 PDF', '缴费后下载摘要模板 Word'],
    submissionRules: ['摘要截止：会前 1 个月', '住宿截止：会前 7 天', '野外报名截止：会前 7 天']
  },
  {
    title: '古植物学分会青年学者论坛',
    branch: '古植物学分会',
    time: '2026.10.12 - 10.14',
    city: '北京',
    status: '即将开始',
    feeRules: {
      studentMember: 360,
      nonStudentMember: 600,
      studentNonMember: 520,
      nonStudentNonMember: 820
    },
    materialRules: ['公开通知不盖章', '缴费后开放盖章通知与摘要模板'],
    submissionRules: ['摘要 Word 仅保留最后一次', '住宿按男/女单间、双人间统计', '野外信息按会前/会中/会后统计']
  },
  {
    title: '微体化石与地层应用研讨会',
    branch: '微体学分会',
    time: '2026.11.06 - 11.08',
    city: '武汉',
    status: '征集中',
    feeRules: {
      studentMember: 420,
      nonStudentMember: 700,
      studentNonMember: 620,
      nonStudentNonMember: 960
    },
    materialRules: ['会议一场一缴', '凭证与发票按学会和会议归档'],
    submissionRules: ['口头报告/展板报告需填写标题', '仅参会无需报告标题', '摘要、住宿、野外信息不得跨学会混放']
  }
]

export const confirmedRequirements = [
  {
    title: '四类会议费',
    detail: '每场会议配置学生会员、普通会员、学生代表、普通代表四类价格。'
  },
  {
    title: '资料下载',
    detail: '未缴费查看不盖章通知，缴费确认后下载盖章通知 PDF 和摘要模板 Word。'
  },
  {
    title: '参会提交',
    detail: '摘要、住宿、野外报名分别按截止时间控制，并按会议集中归档。'
  },
  {
    title: '入会退会',
    detail: '入会和有效会员退会均需提交申请书模板，经管理员审核后流转状态。'
  }
]

export const userBindingFlow = [
  '选择总学会或分会',
  '绑定后查看对应会议通知',
  '解绑后停止接收该分会内容',
  '绑定/解绑均记录操作日志'
]

export const participantInfoItems = [
  '报告类型：口头报告、展板报告、仅参会',
  '报告标题：口头/展板报告必填',
  '摘要 Word：截止前可替换，仅保留最后一次',
  '住宿：男单、男双、女单、女双、自主安排',
  '野外报名：会前、会中、会后路线与性别统计'
]

export const membershipFlow = [
  {
    step: '下载入会申请书',
    detail: '用户在会员注册界面下载管理员维护的 Word 模板。'
  },
  {
    step: '上传电子申请书',
    detail: '学生会员和普通会员都必须上传入会申请书。'
  },
  {
    step: '管理员审核',
    detail: '审核通过后，用户才能进入会员费缴纳阶段。'
  },
  {
    step: '上传会员费凭证与发票',
    detail: '凭证、发票、会员类型和有效期绑定到用户历史记录。'
  },
  {
    step: '退会申请',
    detail: '有效会员退会需上传退会申请书，审核通过后解除会员资格。'
  }
]
